import React, { useEffect, useState, useContext, useRef } from 'react';
import ContentHeader from './ContentHeader';
import HeaderDefault from './HeaderDefault';
import Footer from './Footer';
import HeaderPolarCare from './HeaderPolarCare';
import AlsamartHeader from './AlsamartHeader';
import HeaderShipBooking from './HeaderShipBooking';
import "primereact/resources/themes/lara-light-blue/theme.css";
import helpers from '../../services/helpers';
//import "primereact/resources/themes/bootstrap4-light-blue/theme.css";

function Layout ({
        page_title='', 
        menu="", 
        breadcrumbs=true, 
        children, 
        parent_link='', 
        parent_text='',
        containerClass="container-fluid"
    }){
    const base_root = window.location.host
    const main_domain = helpers.getMainDomain()

    function DisplayHeader(){
        // if(base_root === "polarcare.polar-air.com" || base_root === "polarcare-staging.polar-air.com"){
        //     return <HeaderPolarCare menu={menu} />
        // }
        // else if(base_root === "alsamart.com" || base_root === "dev.alsamart.com"){
        //     return <AlsamartHeader menu={menu} />
        // }
        // else if(base_root === "app.sanricardoshipping.com" || 
        //     base_root === "dashboard.sanricardoshipping.com" || 
        //     base_root === "admin.sanricardoshipping.com" || 
        //     base_root === "sandbox.sanricardoshipping.com" || 
        //     base_root === "booking.sanricardoshipping.com" || 
        //     base_root === "sanricardoshipping.com"
        // ){
        //     return <HeaderShipBooking menu={menu} />
        // }
        if(main_domain === "polar-air.com"){
            return <HeaderPolarCare menu={menu} />
        }
        else if(main_domain === "alsamart.com"){
            return <AlsamartHeader menu={menu} />
        }
        else if(main_domain === "sanricardoshipping.com"){
            return <HeaderShipBooking menu={menu} />
        }

        //return <HeaderShipBooking menu={menu} />
        return <HeaderDefault menu={menu} />
    }
    
    return (
        <div>
            {/* {
                base_root === "polarcare.polar-air.com" || base_root === "polarcare-staging.polar-air.com" ?
                <HeaderPolarCare menu={menu} /> : <Header menu={menu} />
            } */}
            <DisplayHeader />

            <div className="content-wrapper pb-3">
                <ContentHeader title={page_title} breadcrumbs={breadcrumbs}  parent_link={parent_link} parent_text={parent_text} containerClass={containerClass} />
                
                <section className="content">
                    {children}
                </section>

            </div>

            <Footer />
        </div>
    )
}
 
export default Layout;